module.exports = __webpack_public_path__ + "static/img/leaf.2245819.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leaf.png
// module id = VFep
// module chunks = 1